import { render, staticRenderFns } from "./_base-select.vue?vue&type=template&id=5ed9d018&scoped=true&"
import script from "./_base-select.vue?vue&type=script&lang=js&"
export * from "./_base-select.vue?vue&type=script&lang=js&"
import style0 from "./_base-select.vue?vue&type=style&index=0&id=5ed9d018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed9d018",
  null
  
)

export default component.exports